import { Typography } from '@mui/material'
import cn from 'classnames'
import React from 'react'

export const CollectionTypographyHome = ({
    author,
    collectionImage,
    collectionThumbnail = collectionImage,
    verified = false,
    blacklisted = false,
    displayName = author,
    href = '/collection/' + author,
    name,
}) => {
    const image =
        process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
            ? collectionImage
            : collectionThumbnail

    return (
        <Typography gutterBottom variant="h5" component="div">
            <div className={'flex justify-start gap-2 '}>
                {image && (
                    <div
                        className={cn(
                            'flex w-10 min-w-10 h-10 my-1 overflow-hidden border-2 border-gray-300 dark:border-gray-600 rounded-md',
                        )}
                    >
                        <img
                            className={cn('w-10 h-10 object-cover')}
                            src={`https://ipfs.hivebp.io/preview?collection=${author}&size=80&hash=${image}`}
                            alt="author"
                            width={24}
                            height={24}
                        />
                    </div>
                )}
                <div className="flex flex-col justify-start w-[200px]">
                    <p className="font-bold  text-start text-black text-base dark:!text-white truncate ">
                        {name}
                    </p>

                    <div className="flex items-center gap-1">
                        <div className={cn('bottom-2 h-full')}>
                            <p
                                className={cn(
                                    '',
                                    {
                                        'text-xs font-medium text-gray-400 md:text-sm':
                                            name && name.length >= 30,
                                    },
                                    {
                                        'text-xs font-medium text-gray-400 md:text-sm':
                                            name && name.length < 30,
                                    },
                                )}
                            >
                                {'by '}
                                {displayName && displayName.length > 20
                                    ? displayName.substring(0, 20) + '...'
                                    : displayName}
                            </p>
                        </div>
                        {verified && !blacklisted && (
                            <div className={cn('w-5 h-4 ml-1 my-auto')}>
                                <img
                                    src={'/verified.svg'}
                                    alt="verified"
                                    width={24}
                                    height={24}
                                />
                            </div>
                        )}
                        {blacklisted && (
                            <div className={cn('w-5 h-4 ml-1 my-auto')}>
                                <img
                                    src={'/blacklisted.svg'}
                                    alt="blacklisted"
                                    width={150}
                                    height={150}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Typography>
    )
}

export default CollectionTypographyHome
